import { wrapMDX } from "./root-mdx"
// import "./src/css/main.css"

export const wrapRootElement = wrapMDX
